import { computed, readonly, ref } from 'vue'

const BASE_Z_INDEX = 1050
const OVERLAY_STEP = 10

const stack = ref([])

export function useOverlayStack(name = 'overlay') {
    const id = Symbol(name)
    const isRegistered = ref(false)

    const registerOverlay = () => {
        if (isRegistered.value) {
            stack.value = stack.value.filter((overlayId) => overlayId !== id)
        }

        stack.value = [...stack.value, id]
        isRegistered.value = true
    }

    const unregisterOverlay = () => {
        if (!isRegistered.value) {
            return
        }

        stack.value = stack.value.filter((overlayId) => overlayId !== id)
        isRegistered.value = false
    }

    const stackIndex = computed(() => stack.value.indexOf(id))
    const resolvedStackIndex = computed(() => {
        return stackIndex.value === -1 ? stack.value.length : stackIndex.value
    })

    const backdropZIndex = computed(() => {
        return BASE_Z_INDEX + resolvedStackIndex.value * OVERLAY_STEP
    })

    const panelZIndex = computed(() => backdropZIndex.value + 1)

    const isTopOverlay = computed(() => {
        return stack.value[stack.value.length - 1] === id
    })

    return {
        backdropZIndex,
        isTopOverlay,
        panelZIndex,
        registerOverlay,
        stack: readonly(stack),
        unregisterOverlay,
    }
}
